var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProspection(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.298,
    height: 85.298,
    viewBox: "0 0 85.298 85.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2889",
    "data-name": "Groupe 2889",
    transform: "translate(-125.459)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 42.649,
    cy: 42.649,
    r: 42.649,
    transform: "translate(125.459)",
    fill: "#af8da1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2466",
    "data-name": "Groupe 2466",
    transform: "translate(145.007 15.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    d: "M18.126,2a16.126,16.126,0,0,0-11.4,27.528A16.126,16.126,0,0,0,29.528,6.723,16.02,16.02,0,0,0,18.126,2m0-2A18.126,18.126,0,1,1,0,18.126,18.126,18.126,0,0,1,18.126,0Z",
    transform: "translate(12.439 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_20",
    "data-name": "Ligne 20",
    d: "M0,18.77a1,1,0,0,1-.707-.293,1,1,0,0,1,0-1.414L17.063-.707a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414L.707,18.478A1,1,0,0,1,0,18.77Z",
    transform: "translate(0 30.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_835",
    "data-name": "Trac\\xE9 835",
    d: "M528.514,1089.866a1,1,0,0,1-.986-1.172,11.313,11.313,0,0,0-.084-3.394,11.1,11.1,0,0,0-3.438-6.438l-.034-.034a10.12,10.12,0,0,0-9.384-3.19,1,1,0,1,1-.532-1.928,10.5,10.5,0,0,1,3.748-.167,12.694,12.694,0,0,1,7.583,3.871,13.237,13.237,0,0,1,4.044,7.638,13.026,13.026,0,0,1,.067,3.987A1,1,0,0,1,528.514,1089.866Z",
    transform: "translate(-486.016 -1068.445)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspection);
export default __webpack_public_path__ + "static/media/prospection.c0d78e7b049183ab64f4ebfeb8a847de.svg";
export { ForwardRef as ReactComponent };